import { NgClass } from '@angular/common';
import { Component, output } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'app-navbar-mobile-menu',
  imports: [NgClass, FontAwesomeModule],
  templateUrl: './navbar-mobile-menu.html',
  styleUrl: './navbar-mobile-menu.scss',
})
export class NavbarMobileMenu {

  isSectorOpen: boolean;
  isProductsOpen: boolean;

  constructor() {
    this.isSectorOpen = false
    this.isProductsOpen = false
  }
  close = output<void>()

  closeDropdown() {
    this.close.emit()
  }

  toggleSection(type: string) {
    if (type == 'sectors') {
      this.isSectorOpen = !this.isSectorOpen
      // si voy a abrirla y la otra está abierta cierra
      if (this.isSectorOpen) {
        this.isProductsOpen = false
      }
    } else {
      this.isProductsOpen = !this.isProductsOpen
      if (this.isProductsOpen) {
        this.isSectorOpen = false
      }
    }
  }
}
